export class Sale {      
  serve_from_branch_id: number;
  id: number;
  order_number: string;
  invoice_number: string;
  client: string;
  salesman: string;
  order_date: string;// = (new Date()).toISOString().substr(0,10);
  delivery_date: string;// = (new Date()).toISOString().substr(0,10);
  qty: number;
  type: string;
  branch: string;
  branch_id: number;
  requesting_branch_id: number;
  //Default to "Draft" status on create
  status: string = 'DRAFT';
  customer_prefix: string;
  customer_name: string;
  customer_id: number;
  customer_po: string;
  notes: string;
  shipping_charges: number = 0;
  discount: number = 0;

  selected_unit: string = '';
  selected_fabric_type_id;

  tax: number = 0;
  tax2: number = 0;

  items: any[] = [];

  prepared_pallet_id: number;

  //links the B2B PO with the Sales Order
  po_id: string; 
}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/sales/sale.ts